import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=33cff3db&scoped=true&"
import script from "./account-detail.vue?vue&type=script&lang=js&"
export * from "./account-detail.vue?vue&type=script&lang=js&"
import style0 from "./account-detail.vue?vue&type=style&index=0&id=33cff3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cff3db",
  null
  
)

export default component.exports